module.exports = __webpack_public_path__ + "img/EGS_icon_06.0ac169c0.svg";